import { useTranslation } from "react-i18next";
import { Props, OnlyCurrentEmployeesOptionValue, OnlyCurrentEmployeesQuickFilter } from "./interfaces";
import { QuickFilterOption } from "../../../reusable-components/QuickFilter/interfaces";

import QuickFilter from "../../../reusable-components/QuickFilter/QuickFilter";

export const CurrentEmployeesQuickfilter = <Q extends OnlyCurrentEmployeesQuickFilter>({
  quickFilters,
  handleChangeQuickFilters,
  customTRP,
}: Props<Q>) => {
  const { t } = useTranslation();
  const tRP = "components.quickfilters.current_employees_filter"; // tRP - translation root path

  const options: QuickFilterOption<OnlyCurrentEmployeesOptionValue>[] = [
    {
      name: `${t(`${customTRP ?? tRP}.current_employee`)} `,
      value: { onlyCurrentEmployees: true },
    },
    {
      name: `${t(`${customTRP ?? tRP}.all`)} `,
      value: { onlyCurrentEmployees: false },
    },
  ];

  return (
    <QuickFilter
      options={options}
      quickFilters={quickFilters}
      quickFilter="onlyWithCurrentEmployees"
      handleChangeQuickFilter={handleChangeQuickFilters}
      shrinkedLabel={`${t(`${customTRP ?? tRP}.shrinked_label`)}`}
    />
  );
};
